import { Module } from 'vuex';
import { Floor } from '@/utils/api';
import { RootState } from '..';
import getFloorByID from '@/utils/helpers/getFloorByID';
import getAdditionalPrice from '@/utils/helpers/getAdditionalPrice';
import { FloorState } from '@/store/modules/app';

const RESET_STATE = 'RESET_STATE';

const basementInitialState = (): FloorState => ({
  floorID: 'BAF'
});

export const basementModule: Module<FloorState, RootState> = {
  namespaced: true,
  state: basementInitialState(),
  getters: {
    floor(_state, _getters, rootState): Floor | undefined {
      const floor: Floor | undefined = getFloorByID(
        rootState.configuration.houseConfiguration?.floors || [],
        _state.floorID
      );

      if (floor?.zones[0]?.modules) {
        floor.zones[0].modules = getAdditionalPrice(floor.zones[0].modules);
      }

      return floor;
    }
  },
  actions: {
    resetState({ commit }) {
      commit(RESET_STATE);
    }
  },
  mutations: {
    [RESET_STATE](state) {
      Object.assign(state, basementInitialState());
    }
  }
};
